import Swal from 'sweetalert2';

const validationList = (questionnaireId) => {
    const loader = window.customLoader;

    document.getElementById('btn-add-validation')?.addEventListener('click', function () {
        Swal.fire({
            title: 'Nowa walidacja',
            input: 'text',
            inputLabel: 'Nazwa walidacji',
            inputPlaceholder: 'np. Walidacja wyników krytycznych',
            showCancelButton: true,
            cancelButtonText: 'Anuluj',
            confirmButtonText: 'Utwórz',
            confirmButtonColor: '#3f51b5',
            cancelButtonColor: '#6c757d',
            inputValidator: (value) => {
                if (!value || !value.trim()) return 'Podaj nazwę walidacji';
            },
        }).then((result) => {
            if (!result.isConfirmed) return;

            loader?.show();

            const formData = new FormData();
            formData.append('name', result.value.trim());

            fetch(Routing.generate('validation_create', { questionnaireId }), {
                method: 'POST',
                body: formData,
            })
                .then((r) => r.json())
                .then((d) => {
                    loader?.hide();
                    if (d.error) {
                        Swal.fire({ icon: 'error', title: 'Błąd', text: d.error, confirmButtonColor: '#3f51b5' });
                    } else {
                        window.location.href = d.redirectUrl;
                    }
                })
                .catch(() => {
                    loader?.hide();
                    Swal.fire({ icon: 'error', title: 'Błąd', text: 'Nie udało się utworzyć walidacji.', confirmButtonColor: '#3f51b5' });
                });
        });
    });

    document.querySelectorAll('.delete-validation').forEach((btn) => {
        btn.addEventListener('click', function () {
            const id = this.dataset.id;

            Swal.fire({
                icon: 'question',
                title: 'Usuń walidację?',
                text: 'Tej operacji nie można cofnąć.',
                showCancelButton: true,
                cancelButtonText: 'Anuluj',
                confirmButtonText: 'Usuń',
                confirmButtonColor: '#dc3545',
                cancelButtonColor: '#6c757d',
            }).then((result) => {
                if (!result.isConfirmed) return;

                loader?.show();

                fetch(Routing.generate('validation_delete', { id }), { method: 'DELETE' })
                    .then((r) => r.json())
                    .then((d) => {
                        loader?.hide();
                        if (d.error) {
                            Swal.fire({ icon: 'error', title: 'Błąd', text: d.error, confirmButtonColor: '#3f51b5' });
                        } else {
                            const row = document.querySelector(`tr[data-id="${id}"]`);
                            row?.remove();
                        }
                    })
                    .catch(() => {
                        loader?.hide();
                        Swal.fire({ icon: 'error', title: 'Błąd', text: 'Nie udało się usunąć walidacji.', confirmButtonColor: '#3f51b5' });
                    });
            });
        });
    });
};

window.initValidationList = (questionnaireId) => validationList(questionnaireId);
